// src/pages/RegisterPage.jsx
import React from "react";
import RegistrationForm from "../pages/RegistrationForm";
import { useTranslation } from "react-i18next";

// Fișiere din folderul public/ (spațiile din nume sunt encodate în URL)
const asset = (name) => `${process.env.PUBLIC_URL}/${name}`;

const RegisterPage = () => {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen ara-hero"
      style={{
        "--bg-desktop": `url("${asset("Fundal-desktop-gol.jpg")}")`,
        "--bg-mobile": `url("${asset("Fundal-mobil-gol.jpg")}")`,
        paddingBottom: "60px",
      }}
    >
      {/* Tot conținutul împarte aceeași lățime cu formularul => aliniat perfect */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-8">

        {/* Branding eveniment — în linie cu formularul.
            Desktop: text stânga / logo dreapta. Mobil: stivuit și centrat. */}
        <div className="flex flex-col items-center gap-5 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <img
            src={asset("Text%20Expo%20Apa.png")}
            alt="EXPOAPA 2026 · 8-10 septembrie · Romexpo București"
            className="h-11 sm:h-14 w-auto max-w-full"
            style={{ filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.4))" }}
          />
          <img
            src={asset("Logo%20Expo%20Apa.png")}
            alt="ExpoApa"
            className="h-16 sm:h-20 w-auto max-w-full"
            style={{ filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.3))" }}
          />
        </div>

        {/* Titlu */}
        <div className="text-center text-white mt-8">
          <h2
            className="font-bold mb-1"
            style={{ fontFamily: '"Aeonik", Arial, sans-serif', fontSize: "clamp(2rem, 7vw, 3rem)" }}
          >
            {t("inregistrare")}
          </h2>
          <p
            className="text-sm opacity-90"
            style={{ fontFamily: '"Aeonik", Arial, sans-serif' }}
          >
            {t("completeaza")}
          </p>
        </div>

        {/* Formular */}
        <div className="shadow-md rounded-2xl p-6 mt-6" style={{ background: "#ffffffe6" }}>
          <RegistrationForm />
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
